import Menu from '../../data/menu'

const state = {
    data: Menu.data,
    searchData: []
}

// helpers
function filterMenuByPermissions(items, permissions) {
    return items.reduce((acc, item) => {
        if (item.permission && !permissions.includes(item.permission)) {
            return acc;
        }
        const clone = { ...item };
        if (item.children) {
            clone.children = filterMenuByPermissions(item.children, permissions);
            // hide a 'sub' parent when all its children are filtered out
            if (item.type === 'sub' && clone.children.length === 0) {
                return acc;
            }
        }
        acc.push(clone);
        return acc;
    }, []);
}

// getters
const getters = {
    filteredMenu: (state, _getters, rootState) => {
        const permissions = rootState.auth ? rootState.auth.permissions : [];
        return filterMenuByPermissions(state.data, permissions);
    },
}

// mutations
const mutations = {
    searchTerm: (state, term) => {
        let items = [];
        term = term.toLowerCase();
        state.data.filter(menuItems => {
            if(menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link'){
              items.push(menuItems);
            }
            if(!menuItems.children) return false
              menuItems.children.filter(subItems => {
                if(subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
                  subItems.icon = menuItems.icon
                  items.push(subItems);
                }
                if(!subItems.children) return false
                subItems.children.filter(suSubItems => {
                  if(suSubItems.title.toLowerCase().includes(term)) {
                    suSubItems.icon = menuItems.icon
                    items.push(suSubItems);
                  }
                })
            })
            state.searchData = items
        });
    },
    setNavActive: (state, item) => {
        // filteredMenu returns shallow clones; find the original in state.data by title
        const findOriginal = (items, target) => {
            for (const a of items) {
                if (a.title === target.title) return a;
                if (a.children) {
                    const found = findOriginal(a.children, target);
                    if (found) return found;
                }
            }
            return null;
        };
        const original = findOriginal(state.data, item) || item;
        if (!original.active) {
            state.data.forEach(a => {
                if (state.data.includes(original))
                    a.active = false;
                if (!a.children) return;
                a.children.forEach(b => {
                    if (a.children.includes(original))
                        b.active = false;
                });
            });
        }
        original.active = !original.active;
    },
    setActiveRoute:(state, item) => {
       state.data.filter(menuItem => {
          if (menuItem != item)
            menuItem.active = false
          if (menuItem.children && menuItem.children.includes(item))
            menuItem.active = true
          if (menuItem.children) {
            menuItem.children.filter(submenuItems => {
              if (submenuItems.children && submenuItems.children.includes(item)) {
                menuItem.active = true
                submenuItems.active = true
              }
            })
          }
        })
    }
};

// actions
const actions = {
    searchTerm: (context, term) => {
        context.commit('searchTerm',term)
    },
    setNavActive: (context, item) => {
        context.commit('setNavActive',item)
    },
    setActiveRoute:(context, item) => {
        context.commit('setActiveRoute', item)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}